// Module
var code = "<tmr-page-title breadcrumbs=\"::$ctrl.breadcrumbs\"> <tmr-page-actions> <tmr-toolbar-button icon=\"o-delete-circle-1\" label=\"{{::$ctrl.cancelText}}\" ng-click=\"$ctrl.onCancel()\"> </tmr-toolbar-button> </tmr-page-actions> </tmr-page-title> ";
// Exports
var _module_exports =code;;
var path = 'components/resourceFormToolbar/resourceFormToolbar.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;